import React, {useState} from 'react'
import { ProfileImage } from '../../../components/ProfileImage'
import styles from './ImageSection.scss'
import { ClientImportLogo, ClientImportSign } from '../../../reducers/clients/clients'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { withTranslation } from 'react-i18next'
import {imageType} from "../../../utils/Form"
import { AddFile } from 'jbc-front/components/icons'


function ImageSectionShow({dispatch, logo, signature, t}) {

    return (
        <div className={styles.imagesection} style={{paddingTop: "20px", justifyContent: "space-evenly"}}>
            <ProfileImage name="logo" label={t('features.Clients.components.ImageSection.client_logo')}
                          image={imageType(logo)} defaultImage={<AddFile size={256} />} />

            <ProfileImage name="signature" label={t('features.Clients.components.ImageSection.client_signature')}
                          image={imageType(signature)} defaultImage={<AddFile size={256} />} />
        </div>
    )
}

const mapStateToProps = state => {
    const signature = state.clients.item.data.clientSignature
    const logo = state.clients.item.data.clientLogo
    return({
        logo: logo,
        signature: signature
    })
}
export default connect(mapStateToProps)(withTranslation()(ImageSectionShow))